import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum DocumentTypeId {
  INVOICE = 1,
  RECEIPT = 2,
  PROFORMA = 3,
  ADVANCE_PAYMENT_DOCUMENT = 4,
  COUPON = 5,
  CREDIT_NOTE = 6,
}

export class DocumentType extends Codebook<DocumentTypeId> {
  static readonly INVOICE = new DocumentType(
    DocumentTypeId.INVOICE,
    () => $t('INV'),
    () => $t('Invoice'),
  )
  static readonly RECEIPT = new DocumentType(
    DocumentTypeId.RECEIPT,
    () => $t('REC'),
    () => $t('Receipt'),
  )
  static readonly PROFORMA = new DocumentType(
    DocumentTypeId.PROFORMA,
    () => $t('PRI'),
    () => $t('Proforma'),
  )
  static readonly ADVANCE_PAYMENT_DOCUMENT = new DocumentType(
    DocumentTypeId.ADVANCE_PAYMENT_DOCUMENT,
    () => $t('APD'),
    () => $t('Advanced payment document'),
  )
  static readonly COUPON = new DocumentType(
    DocumentTypeId.COUPON,
    () => $t('COU'),
    () => $t('Coupon'),
  )
  static readonly CREDIT_NOTE = new DocumentType(
    DocumentTypeId.CREDIT_NOTE,
    () => $t('CRE'),
    () => $t('Credit Note'),
  )

  private constructor(
    public readonly id: DocumentTypeId,
    public readonly shortcut: () => string,
    public readonly label: () => string,
  ) {
    super(id)
  }

  static allForDocumentNumbering = (): DocumentType[] => {
    return [
      DocumentType.INVOICE,
      DocumentType.RECEIPT,
      DocumentType.PROFORMA,
      DocumentType.ADVANCE_PAYMENT_DOCUMENT,
      DocumentType.CREDIT_NOTE,
    ]
  }
}
